import type { FlashSameRoomSelection, OfferPageMultiRoomMode, OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'

function homogeneousExplicitRoom(rooms: Array<OfferPageRoom>, mode?: OfferPageMultiRoomMode): OfferPageRoom | undefined {
  if (rooms.length > 1 && mode !== 'same-room') return undefined
  const first = rooms[0]
  if (!first?.roomId || !first.rateId) return undefined
  const extras = [...first.optionalBundleIds ?? []].sort().join('|')
  return rooms.every(room => room.roomId === first.roomId && room.rateId === first.rateId && [...room.optionalBundleIds ?? []].sort().join('|') === extras) ? first : undefined
}

export function getInitialFlashSameRoomSelection(offer: Pick<App.HotelOffer, 'id' | 'packages'>, rooms: Array<OfferPageRoom>, duration?: number, mode?: OfferPageMultiRoomMode): FlashSameRoomSelection | undefined {
  const first = homogeneousExplicitRoom(rooms, mode)
  if (!first) return undefined
  const candidates = offer.packages.filter(pkg => (pkg.id === first.roomId || pkg.roomType?.id === first.roomId) && pkg.roomRate.id === first.rateId && pkg.duration === duration)
  const chosen = candidates.length === 1 ? candidates[0] : undefined
  return chosen ? { offerId: offer.id, packageKey: chosen.uniqueKey } : undefined
}
